import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";

import { Images } from "../../../../../../assets/images";
import {
  PAGINATION,
  MEDIA_TYPES,
  recapConstants,
  FILE_EXTENSIONS,
} from "../../../../../../constants";
import { convertHeicToJpeg, customToast } from "../../../../../../shared";
import VideoModal from "../../../../../../shared/components/Modal/VideoModal";
import CustomModal from "../../../../../../shared/components/Modal/CustomModal";
import UploadEventActionCard from "../../../../../../shared/components/Events/UploadEventActionCard";
import SingleRecapFeedback from "../../../../../../shared/components/RecapFeedback/SingleRecapFeedback";
import RecapUploadPreview from "../../../../../../shared/components/RecapUploadPreview/RecapUploadPreview";
import { shutterbDashboardActions } from "../../../../../../redux/actions";

const ChangeRequestsReelEvents = (props) => {
  const [files, setFiles] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccessful, setIsSuccessful] = useState(false);
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [mediaUrl, setMediaUrl] = useState(null);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  useEffect(() => {
    if (isSuccessful) {
      setIsModalOpen(false);
      setFiles([]);
      setUploadPercentage(0);
      props.closeAllSubAccordions();
    }
    // eslint-disable-next-line
  }, [isSuccessful]);

  const handleFileInputChange = async (event) => {
    const selectedFiles = event;
    // throwing error in case of image selection
    let isImg = Array.from(selectedFiles).filter((file) =>
      file.type.includes(MEDIA_TYPES.IMAGE)
    );
    if (isImg.length > 0) {
      customToast("Only videos are acceptable for Reel.", toast.TYPE.ERROR);
      return null;
    }
    const convertedFiles = await Promise.all(
      Array.from(selectedFiles).map(async (file) => {
        const fileExtension = file.name.split(".").pop().toLowerCase();

        if (
          !file.type.includes(MEDIA_TYPES.IMAGE) &&
          !file.type.includes(MEDIA_TYPES.VIDEO)
        ) {
          customToast("File format not supported", toast.TYPE.ERROR);
          return null;
        }

        if (
          file.type.includes(MEDIA_TYPES.IMAGE) &&
          (fileExtension === FILE_EXTENSIONS.HEIC ||
            fileExtension === FILE_EXTENSIONS.HEIF)
        ) {
          // Convert HEIC image to JPEG
          const convertedFile = await convertHeicToJpeg(file);
          return {
            file: convertedFile,
            url: URL.createObjectURL(convertedFile),
            selected: false,
          };
        } else {
          return {
            file,
            url: URL.createObjectURL(file),
            selected: false,
          };
        }
      })
    );

    // Filter out any null entries from unsupported formats
    const validFiles = convertedFiles.filter((file) => file !== null);
    setFiles(validFiles);
  };

  const handleRecapSubmit = () => {
    let formdata = new FormData();
    formdata.append("file", files[0].file);
    formdata.append("Id", props.recap.id);
    formdata.append("UserId", props.userId);

    props.addShutterbChangeRequestReelEvent(
      formdata,
      props.sbUserId,
      PAGINATION.PAGE_NUMBER,
      PAGINATION.PAGE_SIZE,
      setIsSuccessful
    );
  };

  const handleOpenVideoModal = (file) => {
    if (file && file.url) {
      setMediaUrl(file.url);
      setIsVideoModalOpen(true);
    }
  };

  return (
    <div className="change-requests-reel-container">
      {props.recap?.galleryChanges.map((recap, index) => (
        <div
          key={recap.eventGalleryId + index}
          className="change-request-reel-event pb-2 mb-3"
        >
          <SingleRecapFeedback
            data={recap}
            actionOptions={recapConstants.OPTIONS}
            disabled={true}
          />
        </div>
      ))}

      <button
        className="button-common button-fill"
        onClick={() => setIsModalOpen(true)}
      >
        upload new recap
      </button>

      <CustomModal
        show={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="add updated recap"
        btnText="finish"
        disabled={files.length === 0}
        onSubmit={handleRecapSubmit}
      >
        <div className="d-flex justify-content-center upload-recap-modal-content">
          {files.length > 0 ? (
            <div className="image-preview-container mt-3">
              <RecapUploadPreview
                id={files.length > 0 ? files[0] : null}
                image={files.length > 0 ? files[0] : null}
                handleOpenModal={handleOpenVideoModal}
                showCheckBox={false}
                showDeleteIcon={true}
                onDelete={() => {
                  setFiles([]);
                  setUploadPercentage(0);
                }}
              />
            </div>
          ) : (
            <UploadEventActionCard
              classes="upload-recap-card"
              iconSrc={Images.VideoPosting}
              iconAlt="video-posting"
              title="upload recaps"
              uploadPercentage={uploadPercentage}
              multiple={false}
              onFilesSelected={(files) => handleFileInputChange(files)}
            />
          )}
        </div>
      </CustomModal>

      <VideoModal
        videoUrl={mediaUrl}
        isOpen={isVideoModalOpen}
        onClose={() => setIsVideoModalOpen(false)}
      />
    </div>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  userId: state.authentication.userId,
  sbUserId: state.shutterbAuthentication.sbUserId,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  addShutterbChangeRequestReelEvent: (
    data,
    sbUserId,
    pageNumber,
    pageSize,
    setIsSuccessful
  ) =>
    dispatch(
      shutterbDashboardActions.addShutterbChangeRequestReelEvent(
        data,
        sbUserId,
        pageNumber,
        pageSize,
        setIsSuccessful
      )
    ),
});

// mapping action and store the function via props
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangeRequestsReelEvents);
